// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../bundler/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../bundler/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.meeting-microphone-status {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 16px;
    box-sizing: border-box;
    min-height: 64px;
    padding: 12px;
    border: 1px solid #e7ecef;
    border-radius: 4px;
    background: #fafbfb;
    color: #04142f;
    font-family: Roboto-Regular, sans-serif;
    font-size: 12px;
    line-height: 20px;
    letter-spacing: 0.48px;
}

.meeting-microphone-status-error {
    background: #fff6eb;
    border-color: #ffe6c7;
}

.meeting-microphone-status-content {
    flex: 1 1 260px;
    min-width: 0;
}

.meeting-microphone-status-heading {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px 8px;
}

.meeting-microphone-status-title {
    font-family: Roboto-Medium, sans-serif;
}

.meeting-microphone-status-indicator {
    flex: 0 0 6px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #e00000;
}

.meeting-microphone-status-pending,
.meeting-microphone-status-description {
    color: #4e5d78;
    overflow-wrap: anywhere;
}

.meeting-microphone-status-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.meeting-microphone-status-actions button {
    box-sizing: border-box;
    min-height: 32px;
    padding: 5px 12px;
    border: 1px solid #c6cdd2;
    border-radius: 4px;
    background: #fff;
    color: #4e5d78;
    font-family: Roboto-Medium, sans-serif;
    font-size: 12px;
    line-height: 20px;
    letter-spacing: 0.48px;
    cursor: pointer;
}

.meeting-microphone-status-actions button:hover {
    background: #f1f3f4;
}

.meeting-microphone-status-actions button:focus-visible {
    outline: 2px solid #0c66ff;
    outline-offset: 2px;
}

.meeting-microphone-status-actions button:disabled {
    opacity: 0.5;
    cursor: default;
}
`, "",{"version":3,"sources":["webpack://./components/NotesView/NotesDV/EditorView/meeting-microphone-status.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;IAEI,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,sCAAsC;IACtC,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB","sourcesContent":[".meeting-microphone-status {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 8px 16px;\n    box-sizing: border-box;\n    min-height: 64px;\n    padding: 12px;\n    border: 1px solid #e7ecef;\n    border-radius: 4px;\n    background: #fafbfb;\n    color: #04142f;\n    font-family: Roboto-Regular, sans-serif;\n    font-size: 12px;\n    line-height: 20px;\n    letter-spacing: 0.48px;\n}\n\n.meeting-microphone-status-error {\n    background: #fff6eb;\n    border-color: #ffe6c7;\n}\n\n.meeting-microphone-status-content {\n    flex: 1 1 260px;\n    min-width: 0;\n}\n\n.meeting-microphone-status-heading {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 4px 8px;\n}\n\n.meeting-microphone-status-title {\n    font-family: Roboto-Medium, sans-serif;\n}\n\n.meeting-microphone-status-indicator {\n    flex: 0 0 6px;\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: #e00000;\n}\n\n.meeting-microphone-status-pending,\n.meeting-microphone-status-description {\n    color: #4e5d78;\n    overflow-wrap: anywhere;\n}\n\n.meeting-microphone-status-actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n}\n\n.meeting-microphone-status-actions button {\n    box-sizing: border-box;\n    min-height: 32px;\n    padding: 5px 12px;\n    border: 1px solid #c6cdd2;\n    border-radius: 4px;\n    background: #fff;\n    color: #4e5d78;\n    font-family: Roboto-Medium, sans-serif;\n    font-size: 12px;\n    line-height: 20px;\n    letter-spacing: 0.48px;\n    cursor: pointer;\n}\n\n.meeting-microphone-status-actions button:hover {\n    background: #f1f3f4;\n}\n\n.meeting-microphone-status-actions button:focus-visible {\n    outline: 2px solid #0c66ff;\n    outline-offset: 2px;\n}\n\n.meeting-microphone-status-actions button:disabled {\n    opacity: 0.5;\n    cursor: default;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
